<template>
  <div class="layout-header" ref="header">
    <div class="header-top">
      <div class="left-box">
        <img class="left-logo" src="@/assets/images/header-logo.png" alt="" />
        <img class="left-logo-1" src="@/assets/images/ksjy.png" alt="" />
      </div>
      <div class="center-box">
        <a-input v-model="keyword" placeholder="输入你要找的资源/活动/赛事" />
        <img
          class="search-icon"
          src="@/assets/images/search.png"
          alt=""
          @click="toSearch"
        />
      </div>
      <div class="right-box">
        <a-popover
          v-if="userInfo"
          overlayClassName="custom-popover-overlay"
          placement="bottomRight"
        >
          <template slot="content">
            <div class="popover-content">
              <div class="popover-item" @click="toPersonCenter">个人中心</div>
              <div class="popover-item" @click="toLoginOut">退出登录</div>
            </div>
          </template>
          <div class="login">
            <div class="login-left">
              <img class="tx" v-if="userInfo.TX" :src="userInfo.TX" alt="" />
              <img
                v-else-if="userInfo.XB === '女'"
                class="tx"
                src="@/assets/images/XB-G-O.png"
                alt=""
              />
              <img v-else class="tx" src="@/assets/images/XB-N-O.png" alt="" />
            </div>
            <div class="login-right">
              <div class="mc">{{ userInfo.XM }}</div>
              <div v-if="userInfo.YHLX" class="js" @click="roleChange">
                我是
                {{
                  `${userInfo.YHLX}` === "1"
                    ? "学校管理者"
                    : `${userInfo.YHLX}` === "2"
                    ? "教师"
                    : `${userInfo.YHLX}` === "3"
                    ? "学生"
                    : `${userInfo.YHLX}` === "4"
                    ? "家长"
                    : `${userInfo.YHLX}` === "6"
                    ? "行政单位管理者"
                    : "其他"
                }}
                <Icon class="js-qh" type="icon-zhankai"></Icon>
              </div>
              <div v-else class="js" @click="roleChange">选择角色</div>
            </div>
          </div>
        </a-popover>
        <div v-else class="not-login" @click="handlerLogin">登录/注册</div>
        <div class="xcx" @click="toJump">小程序</div>
      </div>
    </div>
    <div class="header-footer" ref="MENUS">
      <div
        class="menus-item-box"
        v-for="(item, index) in menus"
        :key="index"
        @click="menuChange(item, index)"
      >
        {{ item.CDMC }}
        <!--        用于占位宽度        -->
        <div
          v-if="activeIndex.includes(item.CDDZ)"
          :ref="`menu_${index}`"
          class="active-menu-item"
        >
          <div>{{ item.CDMC }}</div>
          <Icon class="munu-icon" type="icon-xian" />
        </div>
        <div v-else class="menu-item-default">{{ item.CDMC }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { gsap } from "gsap";
import { message } from "ant-design-vue";
import { postLogout } from "@/api/layout";
import { localRemove } from "@/utils/common-method";
export default {
  props: {
    PATH: {
      type: String,
      default: () => "/",
    },
  },
  data() {
    return {
      menusArr: [
        {
          title: "首页",
          path: "/home",
        },
        {
          title: "教学资源",
          path: "/teaching-resources",
        },
        {
          title: "AI工具",
          path: "/ai-tools",
        },
        {
          title: "赛事活动",
          path: "/event-activities",
        },
        {
          title: "话题专区",
          path: "/topic-zone",
        },
        {
          title: "课堂互动",
          path: "/classroom-interaction",
        },
        // {
        //     title: '优秀成果',
        //     path: '/outstanding-achievements'
        // },
        {
          title: "经典方案",
          path: "/classic-solution",
        },
        {
          title: "专家智库",
          path: "/expert-think-tank",
        },
      ],
      keyword: undefined,
      activeIndex: "/",
      timeline: null,
    };
  },
  mounted() {
    // this.initMenus()
    this.initAnimate();
  },
  watch: {
    PATH: {
      handler(newPath) {
        this.activeIndex = newPath;
        if (newPath.startsWith("/search/"))
          this.keyword = decodeURIComponent(newPath.slice(8, newPath.length));
      },
      immediate: true,
    },
  },
  computed: {
    menus() {
      return this.$store.state.MENUS;
    },
    userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  methods: {
    toJump() {
      // this.$router.push({
      //   path: "/umi/#/index",
      // });
    },
    toSearch() {
      if (this.keyword) {
        if (this.$route.params.pathMatch == this.keyword) return;
        if (this.$route.path.startsWith("/search/")) {
          this.$router.replace({
            path: `/search/${encodeURIComponent(this.keyword)}`,
          });
        } else {
          this.$router.push({
            path: `/search/${encodeURIComponent(this.keyword)}`,
          });
        }
      } else {
        if (this.$route.path.startsWith("/search/")) {
          this.$router.go(-1);
        } else {
          message.error("请输入你要找的资源/活动/赛事！");
        }
      }
    },
    // 退出登录
    toLoginOut() {
      const _this = this;
      _this.$confirm({
        title: "退出登录",
        content: "是否确认退出当前账号",
        centered: true,
        onOk() {
          postLogout().then((res) => {
            if (res) {
              if (res.code === 200) {
                message.success("退出登录成功");
                localRemove("TOKEN");
                localRemove("USERINFO");
                _this.$store.dispatch("set_token", "");
                _this.$store.dispatch("set_userInfo", null);
                window.location.reload();
              } else {
                message.error(res.message || "退出登录失败");
              }
            } else {
              localRemove("TOKEN");
              localRemove("USERINFO");
              _this.$store.dispatch("set_token", "");
              _this.$store.dispatch("set_userInfo");
              window.location.reload();
            }
          });
        },
        onCancel() {},
      });
    },
    // 个人中心
    toPersonCenter() {
      if (this.$route.path === "/person-center/personal-information") return;
      this.$router.push({ path: "/person-center" });
    },
    // 点击登录
    handlerLogin() {
      const _this = this;
      _this
        .$login({ TYPE: "LOGIN" })
        .then((token) => {
          _this.$store.dispatch("set_token", token);
          window.location.reload();
        })
        .catch((reason) => {
          if (reason !== "cancel") console.log("登录取消");
        });
    },
    roleChange() {
      this.$login({ TYPE: "ROLE" })
        .then(() => {
          this.$store.dispatch("set_userinfo");
          if (this.$route.path !== "/home") this.$router.replace({ path: "/" });
        })
        .catch((reason) => {
          if (reason !== "cancel") {
            console.log("角色切换取消");
          }
        });
    },
    // 初始动画
    initAnimate() {
      if (this.timeline) this.timeline.kill();
      this.timeline = gsap.timeline();
      this.timeline
        .to(this.$refs.header, {
          duration: 1,
          ease: "power2.out",
        })
        .fromTo(
          ".layout-header",
          {
            opacity: 0,
            y: -100,
          },
          {
            opacity: 1,
            y: 0,
            stagger: 0.1,
            duration: 1,
            ease: "back.out(1.7)",
          },
          "<0.2"
        );
    },
    // 菜单切换动画
    animateMenu(index) {
      if (this.timeline) this.timeline.kill();
      this.timeline = gsap.timeline();
      this.timeline
        .to(this.$refs[`menu_${index}`], {
          duration: 0.6,
          ease: "power2.out",
        })
        .fromTo(
          ".active-menu-item",
          {
            opacity: 0,
            y: 10,
          },
          {
            opacity: 1,
            y: 0,
            stagger: 0.1,
            duration: 0.2,
            ease: "back.out(1.7)",
          },
          "<0.2"
        );
    },
    // 菜单变更
    menuChange(item, index) {
      if (this.activeIndex === item.CDDZ) return;
      this.activeIndex = item.CDDZ;
      this.$nextTick(() => {
        this.animateMenu(index);
        this.$router.push({ path: item.CDDZ });
      });
    },
    sendMsg() {
      // const params = {
      //     name: "张绍刚ssss",
      //     age: 120,
      //     sex: "男",
      //     phone: "1302222201",
      // }
      // messageEvent.emit(USER_INFO, params)
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-header {
  position: sticky;
  top: 0;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  background-color: #ffffff;
  border-bottom: 1px solid #bbd0e8;

  .header-top {
    width: 1200px;
    height: 69px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .left-box {
      display: flex;
      flex-direction: row;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;

      .left-logo {
        width: 226px;
        height: 35px;
      }

      .left-logo-1 {
        margin-left: 2px;
        width: 126px;
        height: 28px;
      }
    }

    .center-box {
      width: 325px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 4px;
      border: 1px solid #f9f9f9;
      padding: 0 10px;
      position: relative;

      ::v-deep input {
        width: 100%;
        height: 40px;
        background-color: #f9f9f9;
        border-radius: 4px;
        border: none;
        outline: none;
        box-shadow: none;
      }

      .search-icon {
        position: absolute;
        top: 50%;
        margin-top: -12px;
        right: 10px;
        width: 24px;
        height: 24px;
        z-index: 100;
      }
    }

    .right-box {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-end;

      .login {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .login-left {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;

          .tx {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            object-fit: cover;
          }
        }

        .login-right {
          margin-left: 6px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;

          .mc {
            font-weight: 400;
            font-size: 16px;
            color: #333333;
          }

          .js {
            font-weight: 400;
            font-size: 12px;
            color: #0067db;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .js-qh {
              width: 12px;
              height: 12px;
            }
          }
        }
        &:hover {
          cursor: pointer;
        }
      }
      .not-login {
        font-weight: 400;
        font-size: 16px;
        color: #333333;

        &:hover {
          cursor: pointer;
        }
      }
      .xcx {
        margin-left: 22px;
        width: 56px;
        height: 22px;
        border-radius: 12px;
        border: 1px solid #0067db;
        font-weight: 400;
        font-size: 12px;
        color: #0067db;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }

  .header-footer {
    width: 1200px;
    height: 56px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .menus-item-box {
      min-width: 128px;
      height: 56px;
      padding: 0 30px;
      position: relative;
      visibility: hidden;
      font-weight: 400;

      .menu-item-default {
        visibility: visible;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        min-width: 128px;
        font-weight: 400;
        font-size: 17px;
        color: #38393d;
        white-space: nowrap;
        background-color: #ffffff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .active-menu-item {
        visibility: visible;
        position: absolute;
        top: -8px;
        right: 0;
        bottom: 0;
        left: 0;
        min-width: 128px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: linear-gradient(to top, #0067db 0%, #00ffe3 100%);
        border-radius: 8px 8px 0px 0px;
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;

        .munu-icon {
          width: 19px;
          height: 5px;
        }
      }

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
